// src/Presentation/Pages/RootLayout.tsx
import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Components/NavBar/Navbar";
import Footer from "../Components/Footer/Footer";
import { GlobalAccountModeModal } from "../Components/Modals/GlobalAccountModeModal";
import ScrollToTopButton from "../Components/UILibrary/ScrollToTopButton";

export default function RootLayout() {
  return (
    <Fragment>
      <Navbar />
      <main className="root__layout__main">
        <Outlet />
      </main>
      <GlobalAccountModeModal />
       <ScrollToTopButton />
      <Footer />
    </Fragment>
  );
}
